import {
  message,
  Col,
  Row,
  TimePicker,
  Button,
  Tooltip,
  Modal,
  Switch,
  Popover,
  Badge,
} from "antd";
import React, { Suspense } from "react";
import { Container, Draggable } from "react-smooth-dnd";
import { applyDrag } from "../../utils/DragUtils";
import InterDraggableListView from "./InterDraggableListView";
import { connect } from "react-redux";
import {
  requestServerPost,
  selectPage,
  requestNodeServerPost,
  requestServerGet,
} from "../../actions";
import moment from "moment";
import ActionButton from "../ActionButton";
import {
  DeleteOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  ExclamationCircleOutlined,
  InfoCircleTwoTone,
  ClockCircleOutlined,
  CloudUploadOutlined,
} from "@ant-design/icons";
import {
  Play,
  Eye,
  Trash2,
  GripVertical,
  Clock,
  Send,
  Image,
  Film,
  Globe,
  Radio,
  Layers,
  Infinity,
} from "lucide-react";
import { getMediaTypeIcon } from "../../helpers/mediaTypeIcons";

import MediaPreviewPopup from "../popups/MediaPreviewPopup";
import DataHelper from "../../helpers/DataHelper";
import PopupManager from "../../managers/PopupManager";
import PlaylistEmptyView from "./PlaylistEmptyView";
import MomentHelper from "../../helpers/MomentHelper";
import { List } from "antd/lib/form/Form";
import PlaylistPreviewPopup from "../popups/PlaylistPreviewPopup";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import {
  DEFAULT_FFILE_SCALING,
  DEFAULT_MUTED,
  DEFAULT_WIDGET_SCALING,
} from "../../Config";
import PermissionManager from "../../managers/PermissionManager";
import { THEME_PALLETE } from "../../Theme";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const { confirm } = Modal;

class DroppablePlaylistMedias extends React.Component {
  constructor() {
    super();
    this.state = { playlistData: null, Medias: [], showThumbnail: true };
    this.mediaPreviewPopupRef = React.createRef();
    this.playlistPreviewPopupRef = React.createRef();
  }

  onPlaylistDataUpdated = () => {
    const { onPlaylistDataUpdated = () => {} } = this.props;
    onPlaylistDataUpdated();
    this.reloadPlaylistData();
  };

  onPreviewClick = () => {
    if (this.playlistPreviewPopupRef.current) {
      const formattedContents = this.state.Medias.map((media) => {
        const { MediaID, Duration = 30, Scale = "fill" } = media;
        return { media_id: MediaID, duration: Duration, scale: Scale };
      });

      const data = { ...this.state.playlistData };
      data.contents = formattedContents;

      // console.log(JSON.stringify(this.state.mediaDatas))
      this.playlistPreviewPopupRef.current.previewPlaylist(
        data,
        this.state.Medias,
      );
    }
  };

  onThumbnailVisibleChanged = (visible) => {
    this.setState({ showThumbnail: visible });
  };
  componentDidMount() {
    this.reloadPlaylistData();
  }

  componentDidUpdate(prevProps) {
    if (
      "playlistID" in this.props &&
      this.props.playlistID !== prevProps.playlistID
    ) {
      this.reloadPlaylistData();
    }
    if (
      this.props.refreshKey !== undefined &&
      this.props.refreshKey !== prevProps.refreshKey
    ) {
      this.reloadPlaylistData();
    }
  }
  reloadPlaylistData = () => {
    const {
      usertoken,
      requestServerGet,
      playlistID = -1,
      selectedBrandData,
    } = this.props;

    if (playlistID < 0) {
      this.setState({ playlistData: null, Medias: [] });
      return;
    }

    DataHelper.getPlaylists(
      { brandid: selectedBrandData.BrandID, playlistid: playlistID },
      this.props,
    ).then((playlistDatas) => {
      if (playlistDatas.length) {
        const playlistData = playlistDatas[0];
        const { Medias } = playlistData;

        const sortedMedias = playlistData.Medias.sort((a, b) => {
          return a.Ordering - b.Ordering;
        });

        playlistData.Medias = sortedMedias;

        this.setState({
          playlistData: playlistData,
          Medias: sortedMedias,
        });
      }
    });
  };

  previewMedia = (data) => {
    if (data && this.mediaPreviewPopupRef.current) {
      console.log("mediaPreviewPopupRef " + JSON.stringify(data));
      this.mediaPreviewPopupRef.current.previewMedia(data);
    }
  };

  saveOrdering = (
    orderedDatas,
    orderingkey = "MediaID",
    target = "media",
    parentID,
  ) => {
    const { usertoken, requestServerPost } = this.props;
    return new Promise((resolve, reject) => {
      const orderings = orderedDatas
        .map((tl) => {
          return tl[orderingkey];
        })
        .reduce((v1, v2) => `${v1},${v2}`, "");

      requestServerPost(
        "update_ordering",
        { target: target, values: orderings, parentid: parentID },
        null,
        (response) => {
          resolve();
        },
        usertoken,
      );
    });
  };

  onDurationChanged = (newDurationMoment, mediaItem) => {
    const { requestServerPost, usertoken, selectedBrandData } = this.props;

    // const newDuration = moment.duration(newDurationMoment).asSeconds()
    const newDuration = MomentHelper.getSecondsDuration(newDurationMoment);

    const params = new FormData();

    params.append("mediaid", mediaItem.MediaID);
    params.append("duration", newDuration);
    params.append("startat", mediaItem.StartAt);
    params.append("muted", mediaItem.Muted);
    params.append("scale", mediaItem.Scale);

    requestServerPost(
      "update_media",
      params,
      {},
      (response) => {
        this.onPlaylistDataUpdated();
      },
      usertoken,
    );
  };

  onMutedChanged = (newSoundValue, mediaItem) => {
    const { requestServerPost, usertoken, selectedBrandData } = this.props;

    // console.log("mediaItem " + mediaItem)
    const params = new FormData();

    params.append("mediaid", mediaItem.MediaID);
    params.append("muted", !newSoundValue);
    params.append("startat", mediaItem.StartAt);
    params.append("scale", mediaItem.Scale);

    requestServerPost(
      "update_media",
      params,
      {},
      (response) => {
        this.onPlaylistDataUpdated();
      },
      usertoken,
    );
  };

  renderVideoIcon = (path) => {
    return (
      <div
        style={{
          backgroundColor: "black",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "20px",
          width: "45px",
          height: "100%",
          margin: "auto",
          objectFit: "contain",
        }}
      >
        <Play
          size={22}
          color="white"
          style={{ position: "absolute", zIndex: 3 }}
        />
        <div
          style={{
            position: "absolute",
            backgroundColor: "black",
            opacity: 0.2,
            width: "100%",
            height: "100%",
            zIndex: 2,
          }}
        ></div>
        <video
          controls={false}
          className="media-thumb"
          style={{ width: "100%", height: "100%", zIndex: 1 }}
        >
          <source src={`${path}#t=2`} type="video/mp4" />
        </video>
      </div>
    );
  };

  launchAssignAndPublish = (palylistData) => {
    const { onAssignPublishCallback } = this.props;
    console.log(
      "launchAssignAndPublish onAssignPublishCallback " +
        onAssignPublishCallback,
    );
    PopupManager.launchPlaylistPublishPopup(
      palylistData,
      onAssignPublishCallback,
    );
  };

  renderActivePeriodInfo = () => {
    const t = this.props.langT;
    return (
      <div>
        <div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                width: "10px",
                height: "10px",
                display: "inline-block",
                backgroundColor: "blue",
                margin: "5px",
                borderRadius: "5px",
              }}
            ></div>{" "}
            <span>{t.statusHasNotStarted}</span>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                width: "10px",
                height: "10px",
                display: "inline-block",
                backgroundColor: "#444",
                margin: "5px",
                borderRadius: "5px",
              }}
            ></div>{" "}
            <span>{t.statusActive}</span>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                width: "10px",
                height: "10px",
                display: "inline-block",
                backgroundColor: "red",
                margin: "5px",
                borderRadius: "5px",
              }}
            ></div>{" "}
            <span>{t.statusExpired}</span>
          </div>
        </div>
      </div>
    );
  };
  render() {
    const {
      noDropCreateMessage = "",
      needsPublishCount = 0,
      noDropEditMessage = "",
      allowDropEdit = true,
      allowDropCreate = true,
      onDelete = () => {},
      onEdit = () => {},
      onDuplicate = () => {},
      usertoken,
      requestServerPost,
      selectedBrandData,
      selectedBranchData,
      allowEdit = true,
      allowDelete = true,
    } = this.props;
    const allowPublishPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_PLAYLIST,
      PermissionManager.PERMISSION_TYPE_PUBLISH,
    );
    const t = this.props.langT;

    let totalDurationSeconds = 0;
    this.state.Medias.forEach((item) => {
      let isExpired = false;
      if (item.StartDate !== "" && item.EndDate !== "") {
        const compareDate = moment(Date());
        const startDate = moment(item.StartDate);
        const endDate = moment(item.EndDate);
        isExpired =
          !compareDate.isBetween(startDate, endDate) &&
          compareDate.isAfter(endDate);
      }
      if (!isExpired) {
        totalDurationSeconds += item.Duration;
      }
    });

    const hrs = Math.floor(totalDurationSeconds / 3600);
    const mins = Math.floor((totalDurationSeconds % 3600) / 60);
    const secs = totalDurationSeconds % 60;
    let formattedTotalDuration = "";
    if (hrs > 0) formattedTotalDuration += `${hrs}h `;
    if (mins > 0 || hrs > 0) formattedTotalDuration += `${mins}m `;
    formattedTotalDuration += `${secs}s`;

    // const publishTitles = [];
    // if (allowAssignScreenPermission) {
    //     publishTitles.push("Assign to Screens")
    // }
    // if (allowPublishPermission) {
    //     publishTitles.push("Publish to Screens")
    // }

    const publishTitleString = t.publish;

    // File type colour coding
    const TYPE_PILL_STYLE = (type) => {
      const map = {
        video: {
          bg: "linear-gradient(135deg,#fee2e2,#fecaca)",
          color: "#dc2626",
          border: "#fca5a5",
        },
        image: {
          bg: "linear-gradient(135deg,#eff6ff,#dbeafe)",
          color: "#2563eb",
          border: "#bfdbfe",
        },
        web: {
          bg: "linear-gradient(135deg,#f0fdf4,#dcfce7)",
          color: "#16a34a",
          border: "#86efac",
        },
        videourl: {
          bg: "linear-gradient(135deg,#fff7ed,#fed7aa)",
          color: "#ea580c",
          border: "#fdba74",
        },
        streamingurl: {
          bg: "linear-gradient(135deg,#faf5ff,#ede9fe)",
          color: "#7c3aed",
          border: "#c4b5fd",
        },
        widget: {
          bg: "linear-gradient(135deg,#f5f3ff,#ede9fe)",
          color: "#7c3aed",
          border: "#c4b5fd",
        },
      };
      return (
        map[type] || {
          bg: "linear-gradient(135deg,#f8fafc,#f1f5f9)",
          color: "#64748b",
          border: "#e2e8f0",
        }
      );
    };

    return (
      <div style={{ padding: "0 0 8px" }}>
        {/* ── Top bar: duration + CTA buttons ── */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 10,
            padding: "12px 16px",
            background: "linear-gradient(135deg,#f8fafc,#f1f5f9)",
            border: "1px solid #e2e8f0",
            borderRadius: 14,
            marginBottom: 12,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                flexShrink: 0,
                background:
                  totalDurationSeconds > 3600
                    ? "linear-gradient(135deg,#fee2e2,#fecaca)"
                    : "linear-gradient(135deg,#eef2ff,#e0e7ff)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Clock
                size={17}
                color={totalDurationSeconds > 3600 ? "#dc2626" : "#6366f1"}
              />
            </div>
            <div>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "#94a3b8",
                }}
              >
                {t.totalActiveDuration}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginTop: 2,
                }}
              >
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: 700,
                    color: totalDurationSeconds > 3600 ? "#dc2626" : "#4f46e5",
                  }}
                >
                  {formattedTotalDuration}
                </span>
                {totalDurationSeconds > 3600 && (
                  <span
                    style={{
                      fontSize: 11,
                      color: "#dc2626",
                      background: "#fee2e2",
                      border: "1px solid #fca5a5",
                      padding: "2px 8px",
                      borderRadius: 20,
                      fontWeight: 600,
                    }}
                  >
                    ⚠ {t.overOneHour}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <button
              onClick={this.onPreviewClick}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 7,
                padding: "9px 18px",
                borderRadius: 10,
                border: "none",
                background: "linear-gradient(135deg,#6366f1,#4f46e5)",
                color: "#fff",
                fontWeight: 600,
                fontSize: 13,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(99,102,241,0.32)",
              }}
            >
              <Play size={14} /> {t.previewPlaylist}
            </button>
            {allowPublishPermission && (
              <button
                onClick={() =>
                  this.launchAssignAndPublish(this.state.playlistData)
                }
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 7,
                  padding: "9px 18px",
                  borderRadius: 10,
                  border: "none",
                  background: "linear-gradient(135deg,#f59e0b,#d97706)",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: 13,
                  cursor: "pointer",
                  boxShadow: "0 2px 8px rgba(245,158,11,0.30)",
                }}
              >
                <Send size={14} /> {publishTitleString}
              </button>
            )}
          </div>
        </div>

        {/* ── Column header ── */}
        <div
          className="pl-header"
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0 10px",
            height: 34,
            background: "#f8fafc",
            borderRadius: 10,
            marginBottom: 6,
            gap: 0,
            fontSize: 10,
            fontWeight: 700,
            color: "#94a3b8",
            textTransform: "uppercase",
            letterSpacing: "0.07em",
          }}
        >
          <div style={{ width: 4, flexShrink: 0 }} />
          {/* accent bar spacer */}
          <div style={{ width: 32, textAlign: "center", flexShrink: 0 }}>#</div>
          <div style={{ flex: "0 0 44px", textAlign: "center" }}>
            <Switch
              checkedChildren={<EyeOutlined />}
              unCheckedChildren={<EyeInvisibleOutlined />}
              checked={this.state.showThumbnail}
              onChange={this.onThumbnailVisibleChanged}
              size="small"
            />
          </div>
          <div style={{ flex: 3 }}>{t.colMediaName}</div>
          <div style={{ flex: "0 0 70px", textAlign: "center" }}>
            {t.colScale}
          </div>
          <div style={{ flex: "0 0 72px", textAlign: "center" }}>
            {t.colType}
          </div>
          <div style={{ flex: "0 0 110px", textAlign: "center" }}>
            {t.colDuration}
          </div>
          <div
            style={{ flex: 2, display: "flex", alignItems: "center", gap: 6 }}
          >
            {t.colActivePeriod}
            <Popover content={this.renderActivePeriodInfo()}>
              <InfoCircleTwoTone style={{ cursor: "pointer", fontSize: 13 }} />
            </Popover>
          </div>
          <div style={{ flex: "0 0 88px", textAlign: "center" }}>
            {t.colActions}
          </div>
          <div style={{ flex: "0 0 28px" }} />
        </div>
        <InterDraggableListView
          style={{ height: "860px", overflow: "scroll" }}
          dragHandleSelector=".column-drag-handle"
          getChildPayload={(i) => this.state.Medias[i]}
          shouldAcceptDrop={(sourceContainerOptions, payload) => {
            return (
              sourceContainerOptions.groupName === "file" ||
              sourceContainerOptions.groupName === "widget" ||
              sourceContainerOptions.groupName === "playlist_media"
            );
          }}
          renderEmpty={() => {
            return <PlaylistEmptyView></PlaylistEmptyView>;
          }}
          onDrop={(dropResult) => {
            if (!this.state.playlistData) {
              if (allowDropCreate) {
                confirm({
                  icon: (
                    <ExclamationCircleOutlined style={{ fontSize: "50px" }} />
                  ),
                  content: (
                    <>
                      No playlist chosen for this channel, would you like to
                      create a new one?
                    </>
                  ),
                  onOk() {
                    PopupManager.launchCreatePlaylistPopup(
                      (playlistData) => {},
                    );
                  },
                  onCancel() {
                    console.log("Cancel");
                  },
                });
              } else {
                if (noDropCreateMessage !== "")
                  Modal.warning({ content: noDropCreateMessage });
              }
              return;
            } else {
              if (!allowDropEdit) {
                if (noDropEditMessage !== "")
                  Modal.warning({ content: noDropEditMessage });
                return;
              }
            }
            const { removedIndex, addedIndex, payload, element } = dropResult;

            if (
              payload &&
              "groupName" in payload &&
              payload.groupName === "file"
            ) {
              const {
                requestServerPost,
                usertoken,
                selectedBrandData,
                data = null,
              } = this.props;
              var params = {};

              const FilePropertiesJSON =
                DataHelper.extractFileProperties(payload);
              const { duration = 30 } = FilePropertiesJSON;

              // console.log("FilePropertiesJSON " + JSON.stringify(FilePropertiesJSON))

              params["playlistid"] = this.state.playlistData.PlaylistID;
              params["brandid"] = selectedBrandData.BrandID;
              params["medianame"] = payload.FileName;
              params["startat"] = 0;
              params["duration"] = parseFloat(duration);
              params["fileid"] = payload.FileID;
              params["scale"] = DEFAULT_FFILE_SCALING;
              params["muted"] = DEFAULT_MUTED;
              params["startdate"] = ""; //moment().format('YYYY-MM-')
              params["enddate"] = ""; //moment().format('YYYY-MM-')
              requestServerPost(
                "create_media",
                params,
                {},
                (response) => {
                  // this.reloadPlaylistData();
                  // console.log("create brand success")
                  const newDropResult = { ...dropResult };
                  newDropResult.payload = response.data;

                  const newArray = applyDrag(this.state.Medias, newDropResult);

                  this.saveOrdering(
                    newArray,
                    "MediaID",
                    "media",
                    this.state.playlistData.PlaylistID,
                  ).then(this.onPlaylistDataUpdated);

                  this.setState({ Medias: newArray });
                },
                usertoken,
              );
            } else if (
              payload &&
              "groupName" in payload &&
              payload.groupName === "widget"
            ) {
              const {
                requestServerPost,
                usertoken,
                selectedBrandData,
                data = null,
              } = this.props;
              var params = {};

              console.log("dropped widget");
              const FilePropertiesJSON =
                DataHelper.extractFileProperties(payload);
              const { duration = 30 } = FilePropertiesJSON;

              params["playlistid"] = this.state.playlistData.PlaylistID;
              params["brandid"] = selectedBrandData.BrandID;
              params["medianame"] = payload.WidgetInstanceName;
              params["mediatype"] = "Widget";
              params["startat"] = 0;
              params["duration"] = parseFloat(duration);
              params["widgetinstanceid"] = payload.WidgetInstanceID;
              params["scale"] = DEFAULT_WIDGET_SCALING;
              params["startdate"] = ""; //moment().format('YYYY-MM-')
              params["enddate"] = ""; //moment().format('YYYY-MM-')
              requestServerPost(
                "create_media",
                params,
                {},
                (response) => {
                  // this.reloadPlaylistData();
                  // console.log("create brand success")
                  const newDropResult = { ...dropResult };
                  newDropResult.payload = response.data;

                  const newArray = applyDrag(this.state.Medias, newDropResult);

                  this.saveOrdering(
                    newArray,
                    "MediaID",
                    "media",
                    this.state.playlistData.PlaylistID,
                  ).then(this.onPlaylistDataUpdated);

                  this.setState({ Medias: newArray });
                },
                usertoken,
              );
            } else {
              const newArray = applyDrag(this.state.Medias, dropResult);

              this.saveOrdering(
                newArray,
                "MediaID",
                "media",
                this.state.playlistData.PlaylistID,
              ).then(this.onPlaylistDataUpdated);

              this.setState({ Medias: newArray });
            }
          }}
          groupName="playlist_media"
          items={this.state.Medias}
          renderItem={(item, index) => {
            const duration = item.Duration;
            const { FileType, UploadFile, Scale, MediaType } = item;

            var icon = null;
            const type = FileType.toLocaleLowerCase();

            if (this.state.showThumbnail) {
              icon = UploadFile;
              switch (type) {
                case "video":
                  icon = this.renderVideoIcon(UploadFile);
                  break;
                case "web":
                case "videourl":
                  icon = getMediaTypeIcon(type, 24);
                  break;
                case "streamingurl":
                  icon = getMediaTypeIcon("streamingurl", 24);
                  break;
                case "image":
                  icon = UploadFile;
                  break;
                default:
                  icon = UploadFile;
                  break;
              }
            }

            const momentDuration = moment.utc(
              moment.duration(duration, "seconds").asMilliseconds(),
            );
            const filePropJSON = DataHelper.extractFileProperties(item);
            const showInfoIcon =
              Object.keys(filePropJSON).length > 0 &&
              "width" in filePropJSON &&
              "height" in filePropJSON;
            const renderFileProperties = (fileProp) => {
              console.log("fileProp " + JSON.stringify(fileProp));
              const { width, height, duration } = fileProp;
              const resolutionString = `Resolution : ${width} X ${height}`;
              var durationString = ``;
              if ("duration" in fileProp) {
                durationString = `Duration : ${duration} seconds`;
              }
              return (
                <div>
                  {[resolutionString, durationString].map((e) => (
                    <div>{e}</div>
                  ))}
                </div>
              );
            };

            const renderScaleButton =
              type === "web" ? null : (
                <Button
                  onClick={() => {
                    PopupManager.launchScaleSelectorPopup(
                      item,
                      this.onPlaylistDataUpdated,
                    );
                  }}
                  shape="round"
                >
                  {Scale}
                </Button>
              );
            const renderIcon =
              typeof icon === "string" ? (
                <img
                  style={{ width: "38px", height: "38px", objectFit: "cover" }}
                  src={icon}
                  alt=""
                />
              ) : (
                <div
                  style={{
                    width: "38px",
                    height: "38px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                  }}
                >
                  {icon}
                </div>
              );

            console.log("item" + JSON.stringify(item));
            const muted = item.Muted === undefined ? true : item.Muted;

            var isExpired = false;
            var isPending = false;
            var isInfinite = false;

            if (item.StartDate !== "" && item.EndDate !== "") {
              var compareDate = moment(Date());
              var startDate = moment(item.StartDate);
              var endDate = moment(item.EndDate);

              // omitting the optional third parameter, 'units'
              isExpired = !compareDate.isBetween(startDate, endDate); //false in this case

              if (isExpired) {
                isPending = compareDate.isBefore(startDate);
              }
            } else {
              isInfinite = true;
            }

            // console.log("isExpired " + isExpired)
            const typePill = TYPE_PILL_STYLE(type);
            const activePeriodNode = (() => {
              if (isInfinite)
                return (
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 4,
                      fontSize: 11,
                      fontWeight: 600,
                      color: "#94a3b8",
                    }}
                  >
                    <Infinity size={13} /> {t.noExpiry}
                  </span>
                );
              const label = `${moment(item.StartDate).format("DD/MM/YY")} – ${moment(item.EndDate).format("DD/MM/YY")}`;
              if (isPending)
                return (
                  <span
                    style={{
                      fontSize: 11,
                      fontWeight: 600,
                      color: "#2563eb",
                      background: "#eff6ff",
                      border: "1px solid #bfdbfe",
                      padding: "2px 8px",
                      borderRadius: 20,
                    }}
                  >
                    ⏳ {label}
                  </span>
                );
              if (isExpired)
                return (
                  <span
                    style={{
                      fontSize: 11,
                      fontWeight: 600,
                      color: "#dc2626",
                      background: "#fee2e2",
                      border: "1px solid #fca5a5",
                      padding: "2px 8px",
                      borderRadius: 20,
                    }}
                  >
                    ✕ {label}
                  </span>
                );
              return (
                <span
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    color: "#16a34a",
                    background: "#f0fdf4",
                    border: "1px solid #86efac",
                    padding: "2px 8px",
                    borderRadius: 20,
                  }}
                >
                  ✓ {label}
                </span>
              );
            })();

            return (
              <LazyLoadComponent>
                <Suspense fallback={null}>
                  {/* Card row with accent bar */}
                  <div
                    key={`${index}_${item.MediaID}`}
                    className="pl-row"
                    style={{
                      display: "flex",
                      alignItems: "stretch",
                      background: "#fff",
                      borderRadius: 14,
                      marginBottom: 6,
                      overflow: "hidden",
                      border: "1px solid #f1f5f9",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                      minHeight: 64,
                    }}
                  >
                    {/* Accent bar */}
                    <div
                      style={{
                        width: 4,
                        flexShrink: 0,
                        background: "linear-gradient(180deg,#818cf8,#6366f1)",
                      }}
                    />

                    {/* Content area */}
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        padding: "0 10px",
                        gap: 0,
                        minWidth: 0,
                      }}
                    >
                      {/* # ordering */}
                      <div
                        style={{
                          width: 32,
                          flexShrink: 0,
                          textAlign: "center",
                          fontSize: 13,
                          fontWeight: 700,
                          color: "#94a3b8",
                        }}
                      >
                        {index + 1}
                      </div>

                      {/* Thumbnail */}
                      <div
                        style={{
                          flex: "0 0 44px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {this.state.showThumbnail && (
                          <div
                            onClick={() => this.previewMedia(item)}
                            style={{
                              width: 38,
                              height: 38,
                              borderRadius: 8,
                              overflow: "hidden",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: "#f1f5f9",
                              flexShrink: 0,
                            }}
                          >
                            {renderIcon}
                          </div>
                        )}
                      </div>

                      {/* Media name + sound toggle */}
                      <div
                        style={{
                          flex: 3,
                          minWidth: 0,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          justifyContent: "center",
                          paddingRight: 8,
                          paddingLeft: this.state.showThumbnail ? 10 : 0,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            minWidth: 0,
                            maxWidth: "100%",
                          }}
                        >
                          <Tooltip title={item.FileName}>
                            <div
                              style={{
                                fontWeight: 500,
                                fontSize: 13,
                                color: "#1e293b",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {item.FileName}
                            </div>
                          </Tooltip>
                          {(type === "video" || type === "videourl") && (
                            <Switch
                              size="small"
                              checked={!muted}
                              onChange={(v) => this.onMutedChanged(v, item)}
                              checkedChildren={
                                <img
                                  style={{
                                    marginTop: "-3px",
                                    width: "14px",
                                    marginLeft: "-2px",
                                  }}
                                  src="/cms/assets/svgs/icons/icon_soundon.svg"
                                  alt=""
                                />
                              }
                              unCheckedChildren={
                                <img
                                  style={{
                                    marginTop: "-3px",
                                    width: "14px",
                                    marginLeft: "-2px",
                                  }}
                                  src="/cms/assets/svgs/icons/icon_soundoff.svg"
                                  alt=""
                                />
                              }
                            />
                          )}
                          {showInfoIcon && (
                            <Popover
                              content={renderFileProperties(filePropJSON)}
                            >
                              <InfoCircleTwoTone
                                style={{ cursor: "pointer", fontSize: 13 }}
                              />
                            </Popover>
                          )}
                        </div>
                        {/* Compact meta row — phones only (tablets and up
                            keep the spacious desktop columns instead).
                            Scale/Duration reuse the real interactive
                            controls so they stay tappable/editable here. */}
                        <div
                          className="pl-info-mobile"
                          style={{
                            alignItems: "center",
                            gap: 6,
                            marginTop: 4,
                            flexWrap: "wrap",
                          }}
                        >
                          {MediaType !== "Widget" && (
                            <button
                              className="pl-mobile-badge"
                              onClick={() =>
                                PopupManager.launchScaleSelectorPopup(
                                  item,
                                  this.onPlaylistDataUpdated,
                                )
                              }
                              style={{
                                border: "1px solid #e2e8f0",
                                cursor: "pointer",
                                pointerEvents: allowEdit ? "auto" : "none",
                              }}
                            >
                              {Scale}
                            </button>
                          )}
                          <span
                            className="pl-mobile-badge"
                            style={{
                              background: typePill.bg,
                              color: typePill.color,
                              borderColor: typePill.border,
                            }}
                          >
                            {FileType}
                          </span>
                          <div
                            className="pl-mobile-badge pl-mobile-duration"
                            style={{
                              pointerEvents: allowEdit ? "auto" : "none",
                            }}
                          >
                            <TimePicker
                              onChange={(dm) =>
                                this.onDurationChanged(dm, item)
                              }
                              className="duration-picker"
                              size="small"
                              allowClear={false}
                              suffixIcon={null}
                              defaultValue={momentDuration}
                              bordered={false}
                              showNow={false}
                            />
                          </div>
                          {activePeriodNode}
                        </div>
                      </div>

                      {/* Scale pill */}
                      <div
                        className="pl-col-desktop"
                        style={{
                          flex: "0 0 70px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          pointerEvents: allowEdit ? "auto" : "none",
                        }}
                      >
                        {MediaType !== "Widget" && (
                          <button
                            onClick={() =>
                              PopupManager.launchScaleSelectorPopup(
                                item,
                                this.onPlaylistDataUpdated,
                              )
                            }
                            style={{
                              padding: "3px 10px",
                              borderRadius: 20,
                              border: "1px solid #e2e8f0",
                              background: "#f8fafc",
                              fontSize: 11,
                              fontWeight: 600,
                              color: "#475569",
                              cursor: "pointer",
                            }}
                          >
                            {Scale}
                          </button>
                        )}
                      </div>

                      {/* Type badge */}
                      <div
                        className="pl-col-desktop"
                        style={{
                          flex: "0 0 72px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span
                          style={{
                            padding: "3px 10px",
                            borderRadius: 20,
                            fontSize: 11,
                            fontWeight: 700,
                            background: typePill.bg,
                            color: typePill.color,
                            border: `1px solid ${typePill.border}`,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {FileType}
                        </span>
                      </div>

                      {/* Duration picker */}
                      <div
                        className="pl-col-desktop"
                        style={{
                          flex: "0 0 110px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          pointerEvents: allowEdit ? "auto" : "none",
                        }}
                      >
                        <TimePicker
                          onChange={(dm) => this.onDurationChanged(dm, item)}
                          className="duration-picker"
                          size="small"
                          allowClear={false}
                          suffixIcon={null}
                          defaultValue={momentDuration}
                          bordered={false}
                          showNow={false}
                          placeholder="Duration"
                          style={{ fontSize: 12 }}
                        />
                      </div>

                      {/* Active period */}
                      <div
                        className="pl-col-desktop"
                        style={{
                          flex: 2,
                          display: "flex",
                          alignItems: "center",
                          paddingRight: 8,
                        }}
                      >
                        {activePeriodNode}
                      </div>

                      {/* Actions */}
                      <div
                        style={{
                          flex: "0 0 88px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 6,
                        }}
                      >
                        <Tooltip title={t.preview}>
                          <button
                            onClick={() => this.previewMedia(item)}
                            style={{
                              width: 32,
                              height: 32,
                              borderRadius: 8,
                              border: "1px solid #e2e8f0",
                              background: "#f8fafc",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Eye size={15} color="#475569" />
                          </button>
                        </Tooltip>
                        {allowDelete && (
                          <Tooltip title={t.delete}>
                            <button
                              onClick={() => {
                                confirm({
                                  title: t.delete,
                                  icon: <ExclamationCircleOutlined />,
                                  content: `Delete "${item.MediaName}"?`,
                                  okText: t.delete,
                                  okButtonProps: { danger: true },
                                  centered: true,
                                  onOk: () => {
                                    requestServerPost(
                                      "delete_media",
                                      { mediaid: item.MediaID },
                                      {},
                                      () => {
                                        message.success(
                                          t.mediaDeleteSuccess(item.MediaName),
                                        );
                                        this.onPlaylistDataUpdated();
                                      },
                                      usertoken,
                                    );
                                  },
                                });
                              }}
                              style={{
                                width: 32,
                                height: 32,
                                borderRadius: 8,
                                border: "1px solid #fee2e2",
                                background: "#fff5f5",
                                cursor: "pointer",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Trash2 size={15} color="#ef4444" />
                            </button>
                          </Tooltip>
                        )}
                      </div>

                      {/* Drag handle */}
                      <div
                        className="column-drag-handle"
                        style={{
                          flex: "0 0 28px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: allowEdit ? "grab" : "default",
                          pointerEvents: allowEdit ? "auto" : "none",
                        }}
                      >
                        <GripVertical size={16} color="#cbd5e1" />
                      </div>
                    </div>
                  </div>
                </Suspense>
              </LazyLoadComponent>
            );
          }}
        ></InterDraggableListView>
        <MediaPreviewPopup ref={this.mediaPreviewPopupRef}></MediaPreviewPopup>

        <PlaylistPreviewPopup
          key="playlisteditor_preview"
          ref={this.playlistPreviewPopupRef}
        ></PlaylistPreviewPopup>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    selectedBrandData: state.selectedBrandData,
    selectedBranchData: state.selectedBranchData,
  };
};

const ConnectedDroppablePlaylistMedias = connect(mapStateToProps, {
  requestServerGet,
  requestServerPost,
  selectPage,
  requestNodeServerPost,
})(DroppablePlaylistMedias);

const DroppablePlaylistMediasWithLang = (props) => {
  const { lang } = useProLanguage();
  const t = PRO_TRANSLATIONS[lang].playlist;
  return <ConnectedDroppablePlaylistMedias {...props} langT={t} />;
};

export default DroppablePlaylistMediasWithLang;
